import { handleError } from "../utils/handleError";

export default function getUrlName(url) {
  const code = extractUrlCode(url);
  if (!code) {
    return url;
  }
  // Mapping of URL codes to their names
  const urlMapping = {
    fp0021: "getTickerList",
    fp0022: "getDocumentsAcrossTime",
    fp0023: "getDocumentsAcrossCompanies",
    fp0024: "getTranscriptDocumentContent",
    fp0025: "getXfData",
    fp0027: "getWebSearchResultsChunks",
    fp0031: "getQueryParamsOpenAI",
    fp0032: "getQueryParamsT5",
    fp0033: "getTabTitle",
    fp0034: "getSourcesFromQuery",
    fp0041: "getAnswerUnit",
    fp0042: "getAnswers",
    fp0043: "getKeywordResults",
    fp0044: "getRelevantContentIds",
    fp0045: "getRelevantRecordsForFundamentals",
    fp0051: "isApproved",
    fp0052: "signIn",
    fp0053: "updateUserShowIntro",
    fp0054: "logUserAnswer",
    fp0055: "logUserQuery",
    fp0056: "logChatMessage",
    fp0057: "chatCompletion",
    fp0058: "getActionSuggestion",
    fp0059: "getSuggestion",
    fp0067: "getRetryQuery_old",
    fp0061: "processFileContent",
    fp0062: "uploadUserFile",
    fp0063: "getUserFiles",
    fp0064: "deleteUserFile",
    fp0065: "retrieveUserFile",
    fp0066: "logChatMessagePrompt",
    fp0067: "getRetryQuery",
    fp0068: "doesAnswerExistInSources",
    fp0050a: "deleteAnswerAsync",
    fp0122: "getDocumentsByQuarter",
  };

  // Check if the code exists in the mapping and return the corresponding URL name
  return urlMapping[code] || url;
}

function extractUrlCode(url) {
  try {
    // Regular expression to match the unique code pattern (fp followed by digits)
    const pattern = /\/(fp\d+)/;
    const match = url.match(pattern);

    // Check if the pattern was found in the URL
    if (match && match.length > 1) {
      // Return the found code, which is in the second element of the match array
      return match[1];
    } else {
      // Return null if no code is found
      return null;
    }
  } catch (error) {
    handleError({
      error,
      location: "L00119622",
    });
    return null;
  }
}
